import React from 'react';
import { searchTerms, searchTypes } from '../../constants';
import { Dropdown } from '@lwt-helix/dropdown';
import PropTypes from 'prop-types';
import { filterIds, terms } from '../constants/agentMovement';
import { setStateData } from '../../common/helpers/state';
import DropDownOption from '../components/common/DropDownOption';
import { popoverTerms } from '../constants/agentProductionConstants';
import { HelixIcon } from '@lwt-helix/helix-icon';
import { columns as colIcon } from '@lwt-helix/helix-icon/outlined';
import Metrics from './components/Metrics';

const TitleRow = ({
    hasResults,
    selectedPeriod,
    setState,
    shouldDisplayMetricsPopover,
    exportButton,
    savedSearchTitle,
    loadedSearchCriteria,
    columns,
    setColumns,
}) => (
    <div className='row w-100 ml-0 my-2 pr-1 py-0'>
        <div className='labels-buttons-container'>
            <div className="d-flex align-items-center">
                <h4 className='title-row text-truncate mb-0 font-gray-primary'>
                    {searchTypes[location.pathname].title}
                </h4>
                {hasResults && (
                    <h6 className="text-truncate mb-0 helix-body">
                        {savedSearchTitle ?? searchTerms.unsaved}
                    </h6>
                )}
            </div>
            {hasResults && !!loadedSearchCriteria && <div className='d-flex'>
                <Dropdown
                    dataLwtId={filterIds.period}
                    toggleProps={{
                        dataLwtId: 'no-split-toggle',
                        id: 'caret',
                        caret: true,
                        children: selectedPeriod,
                        className: 'bg-dark btn btn-sm btn-secondary mr-2'
                    }}
                    items={[
                        {
                            dataLwtId: filterIds.last365,
                            itemText: terms.last365Days,
                            key: 'item_1',
                            onClick: () => setStateData('selectedPeriod', terms.last365Days, setState)
                        }
                    ]}
                    menuProps={{
                        dataLwtId: filterIds.menu,
                        right: true
                    }}
                />
                <DropDownOption
                    dataLwtId={filterIds.metrics}
                    popoverInnerClassName='popover-menu-width-800 helix-heading'
                    popoverPlacement={popoverTerms.bottomEnd}
                    popoverIsOpen={shouldDisplayMetricsPopover}
                    togglePopover={() => setStateData('shouldDisplayMetricsPopover', !shouldDisplayMetricsPopover, setState)}
                    mainTitle={<HelixIcon icon={colIcon} className='mr-2' />}
                    popoverBody={<Metrics columns={columns} setColumns={setColumns} />}
                />
                {exportButton}
            </div>}
        </div>
    </div>
);


TitleRow.propTypes = {
    hasResults: PropTypes.bool.isRequired,
    selectedPeriod: PropTypes.string.isRequired,
    setState: PropTypes.func.isRequired,
    shouldDisplayMetricsPopover: PropTypes.bool.isRequired,
    exportButton: PropTypes.node,
    savedSearchTitle: PropTypes.string,
    loadedSearchCriteria: PropTypes.object,
    columns: PropTypes.array.isRequired,
    setColumns: PropTypes.func.isRequired,
};

export default TitleRow;
